'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
require('../../../../popmotion/dist/es/utils/clamp.js');
require('../../../../popmotion/dist/es/animations/generators/spring.js');
require('../../../../popmotion/dist/es/utils/progress.js');
require('../../../../popmotion/dist/es/utils/mix.js');
require('../../../../popmotion/dist/es/utils/mix-color.js');
const pipe = require('../../../../popmotion/dist/es/utils/pipe.js');
require('../../../../popmotion/dist/es/utils/mix-complex.js');
require('../../../../popmotion/dist/es/utils/interpolate.js');
require('../../../../popmotion/dist/es/easing/utils.js');
require('../../../../popmotion/dist/es/easing/index.js');
require('../../../../popmotion/dist/es/animations/generators/keyframes.js');
require('../../../../popmotion/dist/es/animations/generators/decay.js');
require('../../../../popmotion/dist/es/animations/index.js');
require('../../../../popmotion/dist/es/utils/velocity-per-second.js');
require('../../../../popmotion/dist/es/animations/inertia.js');
require('../../../../popmotion/dist/es/utils/is-point.js');
require('../../../../popmotion/dist/es/utils/is-point-3d.js');
require('../../../../popmotion/dist/es/utils/distance.js');
require('../../../../popmotion/dist/es/easing/cubic-bezier.js');
const usePointerEvent = require('../events/use-pointer-event.js');
const lock = require('./drag/utils/lock.js');
const types = require('../render/utils/types.js');
const useUnmountEffect = require('../utils/use-unmount-effect.js');
const isNodeOrChild = require('./utils/is-node-or-child.js');

/**
 * @param handlers -
 * @internal
 */
function useTapGesture(_a, visualElement) {
  var onTap = _a.onTap,
    onTapStart = _a.onTapStart,
    onTapCancel = _a.onTapCancel,
    whileTap = _a.whileTap;
  var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
  var isPressing = React.useRef(false);
  var cancelPointerEndListeners = React.useRef(null);
  function removePointerEndListener() {
    var _a;
    (_a = cancelPointerEndListeners.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEndListeners);
    cancelPointerEndListeners.current = null;
  }
  function checkPointerEnd() {
    var _a;
    removePointerEndListener();
    isPressing.current = false;
    (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(types.AnimationType.Tap, false);
    return !lock.isDragActive();
  }
  function onPointerUp(event, info) {
    if (!checkPointerEnd()) return;
    /**
     * We only count this as a tap gesture if the event.target is the same
     * as, or a child of, this component's element
     */
    !isNodeOrChild.isNodeOrChild(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info) : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
  }
  function onPointerCancel(event, info) {
    if (!checkPointerEnd()) return;
    onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
  }
  function onPointerDown(event, info) {
    var _a;
    removePointerEndListener();
    if (isPressing.current) return;
    isPressing.current = true;
    cancelPointerEndListeners.current = pipe.pipe(usePointerEvent.addPointerEvent(window, "pointerup", onPointerUp), usePointerEvent.addPointerEvent(window, "pointercancel", onPointerCancel));
    onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
    (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(types.AnimationType.Tap, true);
  }
  usePointerEvent.usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
  useUnmountEffect.useUnmountEffect(removePointerEndListener);
}

exports.useTapGesture = useTapGesture;
